if (!customElements.get('blog-filter')) {
  customElements.define(
    'blog-filter',
    class BlogFilter extends HTMLElement {
      constructor() {
        super();
        this.container = this.closest('.main-blog');
        this.blogGrid = this.container.querySelector('#BlogArticlesGrid');
        this.blogCategoriesList = this.querySelector('.blog-filter-categories');
        this.links = this.querySelectorAll('a');
        this.links.forEach((link) => {
          link.addEventListener('click', this.handleLinkClick.bind(this));
        });
      }
      changePageInURL(pageNumber) {
        if (pageNumber == undefined) return;

        let url = new URL(window.location);
        url.searchParams.set('page', pageNumber);
        window.history.pushState({}, '', url);
      }
      handleLinkClick(e) {
        e.preventDefault();
        if (this.blogGrid.classList.contains('loading')) return;

        let link = e.target.closest('a');

        let href = link.href;
        this.blogGrid.classList.add('loading');
        this.blogCategoriesList.classList.add('loading');

        fetch(href)
          .then((response) => response.text())
          .then((responseText) => {
            const html = responseText;
            const parsedHTML = new DOMParser().parseFromString(html, 'text/html');
            let responseBlogGrid = parsedHTML.querySelector('#BlogArticlesGrid');
            this.blogGrid.innerHTML = responseBlogGrid.innerHTML;

            let responseCount = parsedHTML.querySelector('#ArticlesCount');
            document.querySelector('#ArticlesCount').innerHTML = responseCount?.innerHTML;
          })
          .catch((e) => {
            window.target.href = href;
          })
          .finally(() => {
            this.links.forEach((link) => link.classList.remove('active'));
            link.classList.add('active');
            this.blogGrid.classList.remove('loading');
            this.blogCategoriesList.classList.remove('loading');
            this.changePageInURL(1);
          });
      }
    }
  );
}
